export default __webpack_public_path__ + "static/y0-ab7b724f5d32b560100e3b756bfce361.mp3";